<template>
  <div>
    <app-notification :title="'דיווחת על מספר לא מזוהה'"
                      :text="'חסמנו את הגישה לתזרים, הצוות שלנו עובד לטפל בבעיה בהקדם האפשרי!'"
                      :icon-type="'danger'"/>
  </div>
</template>

<script>
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';

export default {
  name: 'MaliciousNumberNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('MaliciousNumberNotificationShown');
  },
};

</script>

<style lang="scss" scoped>
</style>
